import type { OperationsCheckDto, OperationsLensKey, OperationsPenKey } from "@/api/endpoints";
import { CHECK_LABEL, lensLabel } from "../operationsLabels";

interface Props {
  checks: OperationsCheckDto[];
  /** Under a lens the stage, flow, owner and status checks reconcile to the lensed open count. */
  lens?: OperationsLensKey;
  pen?: OperationsPenKey;
  lensedOpenNow?: number;
}

/** Panel 8: the reconciliation strip. A failure is a data anomaly to look at, never hidden. */
export function ChecksStrip({ checks, lens, pen, lensedOpenNow }: Props) {
  const label = lensLabel(lens, pen);
  return (
    <section className="ops-span-12">
      <div className="ops-checks" role="list" aria-label="Consistency checks">
        <span className="lbl">
          Consistency checks
          {label && <small className="muted"> · lensed cards reconcile to the {lensedOpenNow ?? 0} {label} items; the attention sum to every open item</small>}
        </span>
        {checks.map((c, i) => (
          <span key={c.name} role="listitem" className={`ops-check ${c.pass ? "pass" : "fail"}`} title={c.detail ?? undefined}>
            <span className="box" aria-hidden="true">{c.pass ? "✓" : "✕"}</span>
            Check {i + 1}, {(CHECK_LABEL[c.name] ?? c.name).toLowerCase()}
            <small>{c.actual} / {c.expected}{c.pass ? "" : ", fail"}</small>
          </span>
        ))}
      </div>
    </section>
  );
}
